import { ConfigStore } from "fs-pb-vue2/store/modules/config";
import { PersonStore } from "fs-pb-vue2/store/modules/person";
import { ContractsStore } from "fs-pb-vue2/store/modules/contracts";
import { Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OperationVue } from "fs-pb-vue2/vueModels/operations/OperationVue";
import IOperationService from "fs-pb-vue2/services/operations/IOperationService";
import { container } from "@/inversify.config";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { ServerCommandsModel } from "fs-pb-vue2/models/serverCommands/serverCommandsModel";
import { PreApprovedSolutionData } from "fs-pb-vue2/data/preApprovedSolutionData";
import { ShowCaseActionType } from "fs-pb-vue2/data/enums/showCaseActionType";

/**
 *  Класс для компоненты модального окна СБП заявок на перевод.
 */
export class PreApprovedSolutionModalVue extends OperationVue {

  /** Входные параметры */
  @Prop() props!: any;

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище счетов
 * @returns {ContractsStore}
 */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /**
 * Хранилище данных пользователя
 * @returns {PersonStore}
 */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  callAction(item: PreApprovedSolutionData): void {
    if (item) {
      switch (item.ActionType) {
        case ShowCaseActionType.Close:
          console.log('Close action');
          break;
        case ShowCaseActionType.OpenLinkInApp:
          this.$router.push(`${item.ActionLink}`)
          break;
        case ShowCaseActionType.OpenLinkInBrowser:
          window.open(this.$options.filters.url(item.ActionLink), '_blank');
          break;
        case ShowCaseActionType.DownloadFile: {
          const link = document.createElement("a");
          link.href = this.$options.filters.url(item.ActionLink);
          link.download = item.ActionLink.substring(item.ActionLink.lastIndexOf('/'));
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          break;
        }
        default:
          console.log('None action');
          break;
      }
    }
  }

  /** Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.ServerCommandsService);
    this.OperationModel = (await this.service.init(
      this.configStore,
      this.personStore,
      this.contractsStore,
      {
        id: this.props.Id,
        Response: this.props.CloseActionCaption
      }
    )) as ServerCommandsModel;
    (this.OperationModel as ServerCommandsModel).buttonCaption = this.props.CloseActionCaption;
    this.loading = false;
  }

  /** Отмена операции */
  async destroyForm(): Promise<void> {
    if ((this.OperationModel as ServerCommandsModel).commandState !== 2) {
      (this.OperationModel as ServerCommandsModel).commandState = -1;
      this.OperationModel = await this.service.execute(this.OperationModel);
    }
    await this.clearForm();
    this.$emit("hideSelf");
  }
}
